import { render, staticRenderFns } from "./tips-point-sale-table.vue?vue&type=template&id=2beb749a"
import script from "./tips-point-sale-table.vue?vue&type=script&lang=js"
export * from "./tips-point-sale-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports